import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Calendar, Phone } from 'lucide-react';

interface BookingCTAProps {
  conversationId?: string;
  onBookingClick: () => void;
  isAutoTriggered?: boolean;
}

export function BookingCTA({ conversationId, onBookingClick, isAutoTriggered }: BookingCTAProps) {
  const handleBooking = async () => {
    console.log('Booking clicked for conversation:', conversationId);
    
    // Track booking intent in conversation
    if (conversationId) {
      const { supabase } = await import('@/integrations/supabase/client');
      await supabase
        .from('chat_conversations')
        .update({ booking_scheduled: true })
        .eq('id', conversationId);
    }

    onBookingClick();
  };

  return (
    <Card className={`p-6 ${isAutoTriggered ? 'bg-gradient-to-br from-primary/20 to-primary/10 border-primary/40' : 'bg-gradient-to-br from-primary/10 to-primary/5 border-primary/20'}`}>
      {isAutoTriggered && (
        <div className="mb-3 flex items-center gap-2 text-sm text-primary font-medium">
          <div className="h-2 w-2 rounded-full bg-primary animate-pulse" />
          AI detected you might benefit from expert guidance
        </div>
      )}
      <div className="flex items-start gap-4">
        <div className="p-3 bg-primary/10 rounded-lg">
          <Calendar className="h-6 w-6 text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold mb-1">
            {isAutoTriggered ? "Let's Get You Unstuck!" : "Need Expert Guidance?"}
          </h3>
          <p className="text-sm text-muted-foreground mb-4">
            {isAutoTriggered 
              ? "Our specialists can provide personalized help via Zoom and get you the right solution faster."
              : "Schedule a free consultation with our real estate tech specialists"}
          </p>
          <Button onClick={handleBooking} size="sm" className={isAutoTriggered ? 'bg-primary' : ''}>
            <Phone className="mr-2 h-4 w-4" />
            Book a Free Call
          </Button>
        </div>
      </div>
    </Card>
  );
}
